import { CommonHeader, TripInfo } from '~/components';
import styles from './Trip.module.scss';
import { useEffect, useRef, useState } from 'react';
import { isSuccess } from '~/utils/api';
import { toast } from 'react-toastify';
import tripApi from '~/api/tripApi';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { genUniqueKey } from '~/utils/common';
import { actions, useStore } from '~/store';
function Trip() {
    const [, dispatch] = useStore();
    const [trips, setTrips] = useState([]);
    const [editingTrip, setEditingTrip] = useState(0);
    const refEditingTrip = useRef(null);

    const handleOnUpdate = ({ id, name }) => {
        setTrips((pre) =>
            pre.map((place) => {
                return place.id === id ? { id, name } : place;
            }),
        );
    };

    const handleOnDelete = ({ id }) => {
        setTrips((pre) => pre.filter((place) => place.id !== id));
    };

    const handleAddTrip = () => {
        const defaultName = 'Chuyến đi chưa đặt tên';
        dispatch(actions.setLoading({ loading: true }));
        const newId = genUniqueKey();
        tripApi
            .insert({ id: newId, name: defaultName })
            .then((res) => {
                // console.log('res', res);
                if (isSuccess(res)) {
                    setTrips((pre) => [
                        { id: newId, name: defaultName },
                        ...pre,
                    ]);
                    setEditingTrip(newId);
                } else {
                    toast.error(res.data);
                }
                dispatch(actions.setLoading({ loading: false }));
            })
            .catch((error) => {
                console.log(error);
                toast.error(JSON.stringify(error));
                dispatch(actions.setLoading({ loading: false }));
            });
    };

    useEffect(() => {
        dispatch(actions.setLoading({ loading: true }));
        tripApi
            .getAll()
            .then((res) => {
                // console.log('res', res);
                if (isSuccess(res)) {
                    setTrips(res.data);
                } else {
                    toast.error(res.data);
                }
                dispatch(actions.setLoading({ loading: false }));
            })
            .catch((error) => {
                console.log(error);
                toast.error(JSON.stringify(error));
                dispatch(actions.setLoading({ loading: false }));
            });
    }, [dispatch]);

    useEffect(() => {
        if (refEditingTrip && refEditingTrip.current) {
            refEditingTrip.current.changeMode('editing');
        }
    }, [editingTrip]);

    return (
        <div className={styles.wrapper}>
            <CommonHeader title={'Chuyến đi'} hidden />
            <div className={styles.addTrip}>
                <button onClick={handleAddTrip}>Thêm chuyến đi mới</button>
            </div>

            <TransitionGroup className={styles.list}>
                {trips.map((trip) => (
                    <CSSTransition
                        key={trip.id}
                        timeout={1000}
                        classNames="item"
                    >
                        <TripInfo
                            ref={
                                editingTrip === trip.id ? refEditingTrip : null
                            }
                            key={trip.id}
                            {...trip}
                            onUpdate={handleOnUpdate}
                            onDelete={handleOnDelete}
                        />
                    </CSSTransition>
                ))}
            </TransitionGroup>
        </div>
    );
}

export default Trip;
